import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    ano,
    formataDataEmMesAnoSemBarra,
} from '../../../business-components/Date/Date'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem2xs4,
    GridItem3,
    GridItem4,
    GridItem5,
    GridItem6,
    GridItem7,
    GridItem8,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import {
    SimNaoRadioGroup
} from '../../../business-rules/RadioGroup/SimNaoRadioGroup'

import {
    ButtonVisualizarDadosBasicos,
    ButtonVisualizarConsideracoesFinais,
    ButtonVisualizarPlanoAcao,
} from '../../../business-components/Button/Button'

import {
    IconButtonConfiguracao,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    calculaJaAposentou,
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaValoresDefaultIniciaisClienteConjuge,
} from '../estudo-parametros/EstudoServiceClienteConjuge'

import {
    dadosCompletosCliente,
} from '../cliente-form/ClienteService'

import {
    calculaVGBLouPGBLVGBL,
    calculaGraficoPrevidenciaPrivada,
} from './PrevidenciaPrivadaServicePrevidenciaPrivada'

import {
    NomeCliente,
    NascimentoCliente,
    IdadeCliente,
    SexoCliente,
} from '../cadastro-form/CadastroCompCliente'

import {
    DataSimulacaoEstudo,
} from '../estudo-parametros/EstudoCompCenarios'

import {
    TaxaJurosAnual,
    TaxaInflacaoAnual,
    TaxaRetornoAnualReal,
} from '../estudo-parametros/EstudoCompTaxas'

import {
    AposentadoriaExpectativaVidaCliente,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompParametros'

import FormForm from '../form-form/FormForm'

import ConsideracoesFinaisForm from '../consideracoesFinais-form/ConsideracoesFinaisForm'

import PrevidenciaPrivadaChart from '../estudo-chart/PrevidenciaPrivadaChart'

import PrevidenciaPrivadaFormPrevidenciaPrivadaBeneficio from './PrevidenciaPrivadaFormPrevidenciaPrivadaBeneficio'

import PrevidenciaPrivadaFormPrevidenciaPrivadaParametros from './PrevidenciaPrivadaFormPrevidenciaPrivadaParametros'

import PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacao from './PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacao'



const PrevidenciaPrivadaFormPrevidenciaPrivada = ( { variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, estudo, vars, linhaFormList, tabClienteFormList, arquivoList, obterArquivoList,
        report, indReport, pagina } ) => {

    if (!report && tabClienteFormList === LABEL.tabClienteFormListPrevidenciaPrivada) {
    
        processaValoresDefaultIniciaisClienteConjuge(values)
    }

    const { VGBLouPGBLVGBL, percDespesaDetutivelRendaTributavel, despesaDetutivelRendaTributavelAnual,
        percPGBL, percPGBLCalc,
            despesaDetutivelAnualPrevidenciaPrivada, despesaDetutivelAnualPrevidenciaPrivadaCalc,
                despesaDetutivelMensalPrevidenciaPrivada, despesaDetutivelMensalPrevidenciaPrivadaCalc,
                    despesaDetutivelAnualComPrevidenciaPrivada, despesaDetutivelAnualLimite,
                        baseCalculoIrRendaTributavelAnual, irRendaTributavelAnual,
                            baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada,
                                irRendaTributavelAnualComPrevidenciaPrivada } =
                                    calculaVGBLouPGBLVGBL(values)

    const { graficoPrevidenciaPrivada, graficoPrevidenciaPrivadaAporte, graficoPrevidenciaPrivadaRentabilidade,
        valorRetiradaMensalMaximaConsumirReservaAposentadoria, graficoPrevidenciaPrivadaConsumirReservaAposentadoria,
            valorRetiradaMensalMaximaPreservarReservaAposentadoria, graficoPrevidenciaPrivadaPreservarReservaAposentadoria,
                indexTotalAcumulado, valorEconomiaInventarioPrevidenciaPrivada} =
                    calculaGraficoPrevidenciaPrivada(values, estudo, {},
                        [{
                            valorAporte: despesaDetutivelMensalPrevidenciaPrivadaCalc,
                            tipoPeriodicidadeAporte: HARDCODE.idTipoPeriodicidadeMensal,
                            mesAnoInicialAporte: formataDataEmMesAnoSemBarra(values.dataSimulacaoEstudo),
                            mesAnoFinalAporte: '12' + values.anoFinalVaiAposentarCliente,
                        }], true)

    const GridItemCheckBox = report ? GridItem6 : GridItem4
    const GridItemTextValidatorValor = report ? GridItem3 : GridItem2



    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <div
                align='left'
                className={values.modoApresentacao ? 'mt-5' : ''}
            >
                {!report && tabClienteFormList === LABEL.tabClienteFormListPrevidenciaPrivada && (
                    <div
                        className='mb-5'
                    >
                        <GridContainer>
                            <GridItem6>
                                <NomeCliente
                                    values={values}
                                    handleChange={handleChange}
                                    jsonConfiguracao={vars.jsonConfiguracao}
                                />
                            </GridItem6>

                            <GridItem6>
                                <GridContainer>
                                    <NascimentoCliente
                                        values={values}
                                        setFieldValue={setFieldValue}
                                    />
                                    <IdadeCliente
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                    <GridItem6
                                        className='mt-2'
                                    >
                                        <SexoCliente
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem6>
                                </GridContainer>
                            </GridItem6>
                        </GridContainer>

                        {dadosCompletosCliente(values) && (
                            <>
                                <GridContainer>
                                    <GridItem2xs4>
                                        <DataSimulacaoEstudo
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                    </GridItem2xs4>

                                    <GridItem2xs4>
                                        <TaxaJurosAnual
                                            values={values}
                                            handleChange={handleChange}
                                        /> 
                                    </GridItem2xs4>

                                    <GridItem2xs4>
                                        <TaxaInflacaoAnual
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem2xs4>

                                    <GridItem2xs4>
                                        <TaxaRetornoAnualReal
                                            values={values}
                                            handleChange={handleChange}
                                            label={LABEL.taxaRetornoAnualReal}
                                        />
                                    </GridItem2xs4>

                                    <GridItem1/>

                                    <GridItem2xs4>
                                        <CustomizedDialogsPopup
                                            maxWidth='xl'
                                            popupTitle={LABEL.buttonDadosBasicos}
                                            PopupButton={ButtonVisualizarDadosBasicos}
                                            bgDefault={true}
                                            popupComponent={
                                                <div
                                                    className='ml-4 mr-4'
                                                >
                                                    <FormForm
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                                        vars={vars}
                                                        arquivoList={arquivoList}
                                                        obterArquivoList={obterArquivoList}
                                                    />
                                                </div>
                                            }
                                        />
                                    </GridItem2xs4>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem8
                                        className='mt-3'
                                    >
                                        {values.taxaJurosAnual || values.taxaInflacaoAnual
                                            ?
                                                <AposentadoriaExpectativaVidaCliente
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                />
                                            :
                                                ''
                                        }
                                    </GridItem8>

                                    <GridItem1/>

                                    <GridItem2xs4>
                                        <CustomizedDialogsPopup
                                            maxWidth='xl'
                                            popupTitle={linhaFormList.labelTabClienteFormListConsideracoesFinais}
                                            PopupButton={
                                                linhaFormList.labelTabClienteFormListConsideracoesFinais ===
                                                    LABEL.tabClienteFormListConsideracoesFinais
                                                        ?
                                                            ButtonVisualizarConsideracoesFinais
                                                        :
                                                            ButtonVisualizarPlanoAcao
                                            }
                                            bgDefault={true}
                                            popupComponent={
                                                <div
                                                    className='ml-4 mr-4'
                                                >
                                                    <ConsideracoesFinaisForm
                                                        variaveisGlobais={variaveisGlobais}
                                                        values={values}
                                                        handleChange={handleChange}
                                                        handleSubmit={handleSubmit}
                                                        setFieldValue={setFieldValue}
                                                        vars={vars}
                                                        linhaFormList={linhaFormList}
                                                    />
                                                </div>
                                            }
                                        />
                                    </GridItem2xs4>
                                </GridContainer>
                            </>
                        )}

                        <CardGridDividerElementos
                            className='mt-5'
                        />
                    </div>
                )}

                {!calculaJaAposentou(values, ano(values.dataSimulacaoEstudo)) && dadosCompletosCliente(values) && (
                    <>
                        {(!report || pagina === 1) && (
                            <GridContainer>
                                <GridItemCheckBox
                                    className={"mt-4 mb-2 font-medium text-muted"}
                                >
                                    {LABEL.contribuiINSSRPPSOuAposentador}
                                </GridItemCheckBox>

                                <GridItem4>
                                    <SimNaoRadioGroup
                                        name={'objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador'}
                                        value={values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador || ''}
                                        onChange={handleChange}
                                        disabled={report}
                                    />
                                </GridItem4>
                            </GridContainer>
                        )}

                        {values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador === 'N' && (!report || pagina === 1) && (
                            <>
                                <h1
                                    className={(report ? 'mt-5' : 'mt-10') + ' mb-5'}
                                >
                                    {LABEL.sugestao}
                                </h1>

                                <h6
                                    className='ml-5'
                                    dangerouslySetInnerHTML={{
                                        __html: MESSAGE().naoContribuiINSSRPPSOuAposentador}}
                                />
                            </>
                        )}

                        {values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador === 'S' && (!report || pagina === 1)  && (
                            <>
                                <GridContainer
                                    className='mt-5'
                                >
                                    <GridItemCheckBox />
                                    <GridItemTextValidatorValor>
                                        <TextValidatorValor
                                            name={"objPrevidenciaPrivada.rendaTributavelAnual"}
                                            label={LABEL.rendaTributavelAnual}
                                            value={
                                                values.objPrevidenciaPrivada.rendaTributavelAnual === 0
                                                    ?
                                                        0
                                                    :
                                                        values.objPrevidenciaPrivada.rendaTributavelAnual || ''
                                            }
                                            onChange={handleChange}
                                            disabled={report}
                                            report={report}
                                        />
                                    </GridItemTextValidatorValor>

                                    <GridItemTextValidatorValor>
                                        <TextValidatorValor
                                            name={"objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada"}
                                            label={LABEL.despesaDetutivelAnualSemPrevidenciaPrivada}
                                            value={
                                                values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada === 0
                                                    ?
                                                        0
                                                    :
                                                        values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada || ''
                                            }
                                            onChange={handleChange}
                                            disabled={report}
                                            report={report}
                                        />
                                    </GridItemTextValidatorValor>

                                    {!report && (
                                        <GridItem1
                                            className='mt-3'
                                        >
                                            <CustomizedDialogsPopup
                                                maxWidth='lg'
                                                popupTitle={LABEL.parametros}
                                                tooltipTitle={LABEL.parametros}
                                                PopupButton={IconButtonConfiguracao}
                                                bgDefault={true}
                                                popupComponent={
                                                    <div
                                                        className='ml-4 mr-4'
                                                    >
                                                        <PrevidenciaPrivadaFormPrevidenciaPrivadaParametros
                                                            values={values}
                                                            handleChange={handleChange}
                                                            handleSubmit={handleSubmit}
                                                        />
                                                    </div>
                                                }
                                            />
                                        </GridItem1>
                                    )}
                                </GridContainer>
                                
                                {VGBLouPGBLVGBL === HARDCODE.VGBLDeclaracaoSimplificada && (
                                    <>
                                        <h1
                                            className={(report ? 'mt-5' : 'mt-10') + ' mb-5'}
                                        >
                                            {LABEL.sugestao}
                                        </h1>
                    
                                        <div
                                            className='ml-5'
                                            dangerouslySetInnerHTML={{
                                                __html: MESSAGE().VGBLDeclaracaoSimplificada}}
                                        />
                                    </>
                                )}

                                {VGBLouPGBLVGBL === HARDCODE.PGBLVGBLDeclaracaoCompleta && (
                                    <>
                                        <h1
                                            className={(report ? 'mt-5' : 'mt-10') + ' mb-5'}
                                        >
                                            {LABEL.sugestao}
                                        </h1>
                    
                                        <div
                                            className='ml-5'
                                            dangerouslySetInnerHTML={{__html:
                                                irRendaTributavelAnual === 0
                                                    ?
                                                        MESSAGE().isentoIR
                                                            .replace('$1$', formataValor(despesaDetutivelAnualPrevidenciaPrivada, 2))
                                                                .replace('$2$', formataValor(despesaDetutivelMensalPrevidenciaPrivada, 2))
 
                                                    :
                                                        MESSAGE(values, report).PGBLVGBLDeclaracaoCompleta
                                                            .replace('$1$', formataValor(despesaDetutivelAnualPrevidenciaPrivada, 2))
                                                                .replace('$2$', formataValor(despesaDetutivelMensalPrevidenciaPrivada, 2))
                                                                    .replaceAll('$3$', formataPerc(percPGBL, 0))
                                            }}
                                        />
                                        
                                    </>
                                )}

                                
                                {VGBLouPGBLVGBL && (
                                    <>
                                        {irRendaTributavelAnualComPrevidenciaPrivada < irRendaTributavelAnual && (
                                            <GridContainer>
                                                <GridItem5>
                                                    <h1
                                                        className='mt-10 mb-5'
                                                    >
                                                        {LABEL.beneficio}
                                                    </h1>

                                                    {despesaDetutivelAnualPrevidenciaPrivada !==
                                                    despesaDetutivelAnualPrevidenciaPrivadaCalc && (
                                                        <div
                                                            className='ml-5'
                                                            dangerouslySetInnerHTML={{
                                                                __html: MESSAGE(values, report).simularAportePGBLInferiorMaximoPossivel
                                                                    .replace('$1$', formataValor(despesaDetutivelAnualPrevidenciaPrivadaCalc, 2))
                                                                    .replace('$2$', formataValor(despesaDetutivelMensalPrevidenciaPrivadaCalc, 2))
                                                            }}
                                                        />
                                                    )}
                                                    
                                                    <div
                                                        className='ml-5'
                                                        dangerouslySetInnerHTML={{
                                                            __html: MESSAGE(values, report).beneficioPGBLVGBLDeclaracaoCompleta
                                                                .replace('$1$', formataValor(irRendaTributavelAnual -
                                                                    irRendaTributavelAnualComPrevidenciaPrivada, 2))
                                                        }}
                                                    />

                                                    <PrevidenciaPrivadaFormPrevidenciaPrivadaBeneficio
                                                        beneficios={
                                                            [
                                                                {
                                                                    descricao: LABEL.baseCalculoIr,
                                                                    valorSemPrevidenciaPrivada: baseCalculoIrRendaTributavelAnual,
                                                                    valorComPrevidenciaPrivada: baseCalculoIrRendaTributavelAnualComPrevidenciaPrivada,
                                                                },
                                                                {
                                                                    descricao: LABEL.ir,
                                                                    valorSemPrevidenciaPrivada: irRendaTributavelAnual,
                                                                    valorComPrevidenciaPrivada: irRendaTributavelAnualComPrevidenciaPrivada,
                                                                },
                                                            ]
                                                        }
                                                        despesaDetutivelAnualPrevidenciaPrivadaCalc={
                                                            despesaDetutivelAnualPrevidenciaPrivadaCalc
                                                        }
                                                        report={report}
                                                    />

                                                    <div
                                                        className='ml-5 mt-10'
                                                        dangerouslySetInnerHTML={{
                                                            __html: MESSAGE(values, report).beneficioPGBLVGBLDeclaracaoCompletaHojeAteAposentadoria
                                                                .replace('$1$', formataValor((irRendaTributavelAnual -
                                                                    irRendaTributavelAnualComPrevidenciaPrivada) *
                                                                        (values.idadeVaiAposentarCliente - values.idadeDataSimulacaoCliente + 1), 2))
                                                                .replace('$2$', estudo.current.anoAtual)
                                                                .replace('$3$', values.anoFinalVaiAposentarCliente)
                                                        }}
                                                    />
                                                </GridItem5>

                                                <GridItem7>
                                                    <PrevidenciaPrivadaChart
                                                        values={values}
                                                        estudo={estudo}
                                                        graficoPrevidenciaPrivada={graficoPrevidenciaPrivada}
                                                        graficoPrevidenciaPrivadaAporte={graficoPrevidenciaPrivadaAporte}
                                                        graficoPrevidenciaPrivadaRentabilidade={
                                                            graficoPrevidenciaPrivadaRentabilidade
                                                        }
                                                        valorRetiradaMensalMaximaConsumirReservaAposentadoria={
                                                            valorRetiradaMensalMaximaConsumirReservaAposentadoria
                                                        }
                                                        graficoPrevidenciaPrivadaConsumirReservaAposentadoria={
                                                            graficoPrevidenciaPrivadaConsumirReservaAposentadoria
                                                        }
                                                        valorRetiradaMensalMaximaPreservarReservaAposentadoria={
                                                            valorRetiradaMensalMaximaPreservarReservaAposentadoria
                                                        }
                                                        graficoPrevidenciaPrivadaPreservarReservaAposentadoria={
                                                            graficoPrevidenciaPrivadaPreservarReservaAposentadoria
                                                        }
                                                        projetoVidaSonho={false}
                                                        indexTotalAcumulado={indexTotalAcumulado}
                                                        report={report}
                                                        simulacao={false}
                                                        despesaDetutivelMensalPrevidenciaPrivadaCalc={
                                                            despesaDetutivelMensalPrevidenciaPrivadaCalc
                                                        }
                                                        valorEconomiaInventarioPrevidenciaPrivada={
                                                            valorEconomiaInventarioPrevidenciaPrivada
                                                        }
                                                    />
                                                </GridItem7>
                                            </GridContainer>
                                        )}

                                        <GridContainer>
                                            <GridItem10>
                                                <h1
                                                    className='mt-10 mb-5'
                                                >
                                                    {LABEL.fundamento}
                                                </h1>

                                                {despesaDetutivelAnualComPrevidenciaPrivada <= despesaDetutivelRendaTributavelAnual &&
                                                despesaDetutivelAnualComPrevidenciaPrivada <= despesaDetutivelAnualLimite 
                                                    ?
                                                        despesaDetutivelRendaTributavelAnual < despesaDetutivelAnualLimite
                                                            ?
                                                                <div
                                                                    className='ml-5'
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: MESSAGE(values, report).fundamentoVGBLDeclaracaoSimplificada1
                                                                            .replace('$1$', formataValor(despesaDetutivelAnualComPrevidenciaPrivada, 2))
                                                                            .replace('$2$', formataValor(
                                                                                round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2), 2))
                                                                            .replace('$3$', formataValor(despesaDetutivelAnualPrevidenciaPrivadaCalc, 2))
                                                                            .replace('$4$', formataPerc(percPGBLCalc))
                                                                            .replace('$5$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                            .replace('$6$', formataValor(despesaDetutivelRendaTributavelAnual, 2))
                                                                            .replace('$7$', formataPerc(percDespesaDetutivelRendaTributavel))
                                                                            .replace('$8$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                    }}
                                                                />
                                                            :
                                                                <div
                                                                    className='ml-5'
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: MESSAGE(values, report).fundamentoVGBLDeclaracaoSimplificada2
                                                                            .replace('$1$', formataValor(despesaDetutivelAnualComPrevidenciaPrivada, 2))
                                                                            .replace('$2$', formataValor(
                                                                                round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2), 2))
                                                                            .replace('$3$', formataValor(despesaDetutivelAnualPrevidenciaPrivadaCalc, 2))
                                                                            .replace('$4$', formataPerc(percPGBLCalc))
                                                                            .replace('$5$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                            .replace('$6$', formataValor(despesaDetutivelAnualLimite, 2))
                                                                    }}
                                                                />
                                                    :
                                                        irRendaTributavelAnual === 0
                                                            ?
                                                                <div
                                                                    className='ml-5'
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: MESSAGE(values, report).fundamentoIsentoIR
                                                                            .replace('$1$', formataValor(
                                                                                round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2), 2))
                                                                            .replace('$2$', formataValor(despesaDetutivelRendaTributavelAnual, 2))
                                                                            .replace('$3$', formataPerc(percDespesaDetutivelRendaTributavel))
                                                                            .replace('$4$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                    }}
                                                                />
                                                            :
                                                                despesaDetutivelAnualComPrevidenciaPrivada > despesaDetutivelAnualLimite
                                                                    ?
                                                                        <div
                                                                            className='ml-5'
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: MESSAGE(values, report).fundamentoPGBLVGBLDeclaracaoCompleta2
                                                                                    .replace('$1$', formataValor(despesaDetutivelAnualComPrevidenciaPrivada, 2))
                                                                                    .replace('$2$', formataValor(
                                                                                        round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2), 2))
                                                                                    .replace('$3$', formataValor(despesaDetutivelAnualPrevidenciaPrivadaCalc, 2))
                                                                                    .replace('$4$', formataPerc(percPGBLCalc))
                                                                                    .replace('$5$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                                    .replace('$6$', formataValor(despesaDetutivelAnualLimite, 2))
                                                                            }}
                                                                        />
                                                                    :
                                                                        <div
                                                                            className='ml-5'
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: MESSAGE(values, report).fundamentoPGBLVGBLDeclaracaoCompleta1
                                                                                    .replace('$1$', formataValor(despesaDetutivelAnualComPrevidenciaPrivada, 2))
                                                                                    .replace('$2$', formataValor(
                                                                                        round(values.objPrevidenciaPrivada.despesaDetutivelAnualSemPrevidenciaPrivada, 2), 2))
                                                                                    .replace('$3$', formataValor(despesaDetutivelAnualPrevidenciaPrivadaCalc, 2))
                                                                                    .replace('$4$', formataPerc(percPGBLCalc))
                                                                                    .replace('$5$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                                    .replace('$6$', formataValor(despesaDetutivelRendaTributavelAnual, 2))
                                                                                    .replace('$7$', formataPerc(percDespesaDetutivelRendaTributavel))
                                                                                    .replace('$8$', formataValor(round(values.objPrevidenciaPrivada.rendaTributavelAnual, 2), 2))
                                                                            }}
                                                                        />
                                                }
                                            </GridItem10>
                                        </GridContainer>
                                    </>
                                )}
                            </>
                        )}

                        {(!report || pagina === 3) && (
                            <GridContainer>
                                <GridItem12>
                                    {!report && (
                                        <h1
                                            className='mt-10 mb-5'
                                        >
                                            {LABEL.simulacao}
                                        </h1>
                                    )}

                                    <PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacao
                                        values={values}
                                        handleChange={handleChange}
                                        estudo={estudo}
                                        report={report}
                                        indReport={indReport}
                                    />
                                </GridItem12>
                            </GridContainer>
                        )}

                        {(!report || (pagina === 1 && values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador === 'N') || pagina === 2 )&& (
                            <GridContainer>
                                <GridItem12>
                                    {values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador && (
                                        <>
                                            <h1
                                                className={(report ? 'mt-4' : 'mt-10') + ' mb-5'}
                                            >
                                                {LABEL.vantagens}
                                            </h1>

                                            <div
                                                className={'ml-5'// + // formatação foi colocada em MESSAGE(values, report).vantagensPrevidenciaPrivada pois não estava dando certo quando gerava o PDF
                                                    //(values.objPrevidenciaPrivada.contribuiINSSRPPSOuAposentador === 'N' && report
                                                    //    ?
                                                    //        ' text-12'
                                                    //    :
                                                    //        ' text-13'
                                                    //)
                                                }
                                                dangerouslySetInnerHTML={{
                                                    __html: MESSAGE(values, report)
                                                        .vantagensPrevidenciaPrivada
                                                            .replaceAll('13px', 
                                                                values.objPrevidenciaPrivada
                                                                    .contribuiINSSRPPSOuAposentador === 'N' ?
                                                                        report ? '10px' : '13px'
                                                                    :
                                                                        report ? '12px' : '13px'
                                                            )
                                                            .replace("$1$", formataPerc(percPGBL, 0))
                                                }}
                                            />
                                        </>
                                    )}
                                </GridItem12>
                            </GridContainer>
                        )}
                    </>
                )}
            </div>
        </ValidatorForm>
    )
}

export default PrevidenciaPrivadaFormPrevidenciaPrivada